import { FC } from 'react';

import { ClientVersionEntity } from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { getVersionDate } from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import { RepresentativeSections } from '../components';
import { RepresentativeSectionsProps } from '../components/RepresentativeSections/types';
import { RepresentativeFormType } from '../forms/representativeForm';

export interface RepresentativeClientVersionViewProps
  extends RepresentativeSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: ClientVersionEntity[];
  initialValues?: RepresentativeFormType;
  fullName: string;
  versionId: string;
  snapshotLoading?: boolean;
  onChangeVersion: (version: ClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const RepresentativeClientVersionView: FC<
  RepresentativeClientVersionViewProps
> = ({
  breadcrumbsTitles,
  versions,
  fullName,
  initialValues,
  snapshotLoading,
  versionId,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <VersionView
      content={
        initialValues && (
          <Form
            initialReadOnly
            initialShowCopyButton
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <RepresentativeSections
              hideActivitySection
              countryRiskAt={getVersionDate(versions, versionId)}
              {...sectionsProps}
            />
          </Form>
        )
      }
      loading={snapshotLoading || !initialValues}
      name={fullName}
      versionId={versionId}
      versions={versions}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  </LayoutWithNavigationBreadcrumbs>
);
